<template>
  <el-dialog
    title="合并"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose"
  >
    <div
      style="position: relative; border-bottom: 1px dashed #ccc"
      v-for="(item, index) in mergeNum"
      :key="index"
    >
      <el-checkbox
        v-model="isKeep[index]"
        :label="item.id"
        :checked="item.provincialExamination === '1'"
        style="
          position: absolute;
          left: 2%;
          top: 50%;
          transform: translate(0, -50%);
        "
        >保留知识点</el-checkbox
      >
      <div style="padding-left: 15%">
        <el-form ref="form" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="知识点名称" :required="true">
                <el-input
                  v-model="item.knowledgeName"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="省考标识:">
                <el-checkbox
                  v-model="item.provincialExamination"
                  :disabled="true"
                  true-label="1"
                  false-label="0"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="知识点描述">
            <el-input
              type="textarea"
              v-model="item.knowledgeDescription"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="创建机构"
            style="display: inline-block; width: 50%"
          >
            <el-input
              v-model="item.institutionName"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="创建人"
            style="display: inline-block; width: 50%"
          >
            <el-input v-model="item.uname" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="mesh">合 并</el-button>
      <el-button type="" @click="keepAdd">返 回</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
export default {
  name: 'KnowledgeMerge',
  components: {},
  inject: ['reload'],
  data() {
    return {
      mergeNum: [],
      isKeep: [],
      loading: false,
      dialogVisible: false,
    }
  },
  methods: {
    // 初始化
    init(ids) {
      this.dialogVisible = true
      console.log(ids)
      this.viewKnowledge(ids)
      console.log(this.mergeNum.length)
    },

    viewKnowledge(id) {
      api.viewKnowledge(id).then(({ data }) => {
        if ((data.code = 100000)) {
          data = data.data
          console.log(data)
          this.mergeNum = data
        }
      })
    },

    mesh() {
      console.log(this.isKeep)
      let ids = ''
      let falseIndex = 0
      let trueNum = 0
      let idArr = []
      let falseObj = ''
      for (let i = 0; i < this.mergeNum.length; i++) {
        idArr.push(this.mergeNum[i].id)
      }

      for (let j = this.isKeep.length - 1; j >= 0; j--) {
        if (this.isKeep[j] == true) {
          trueNum++
          falseIndex = j
          ids += idArr[j] + ','
        } else {
          falseObj += idArr[j]
        }
      }
      if (trueNum == this.isKeep.length) {
        this.$message({ type: 'error', message: `只能保留一个知识点` })
      } else if (trueNum < this.isKeep.length - 1) {
        this.$message({ type: 'error', message: `只能不保留一个知识点` })
      } else {
        api.mergeKnowledge(ids, falseObj).then(({ data }) => {
          if ((data.code = 100000)) {
            console.log(data)
            this.$message({ type: 'success', message: `知识点合并成功` })
            this.dialogVisible = false
            this.$emit('closeMergeDialog')
          }
        })
      }
    },

    // 获取数据
    getList() {},

    handleClose() {
      this.dialogVisible = false
      this.$emit('closeMergeDialog')
    },

    keepAdd() {
      this.dialogVisible = false
      this.$emit('closeMergeDialog')
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
<style>
.el-notification__content {
  text-align: center;
}
</style>
